import(/* webpackMode: "eager" */ "/home/runner/work/gse-sst-deployment/gse-sst-deployment/packages/frontend/src/app/faq/page.tsx");
